import { AgentAcknowledgementTask } from '../common/Compliance/AgentAcknowledgementTask';

enum ComplianceFilingsByCommendaDefaultTaskGroups {
  ACKNOWLEDGEMENT = 'ACKNOWLEDGEMENT',
}

enum ComplianceFilingsByCommendaDefaultTasks {
  UPLOAD_FILINGS_ACKNOWLEDGEMENT = 'UPLOAD_FILINGS_ACKNOWLEDGEMENT',
}

export const COMPLIANCE_FILINGS_BY_COMMENDA_DEFAULT_COMPONENT_MAP = {
  [ComplianceFilingsByCommendaDefaultTasks.UPLOAD_FILINGS_ACKNOWLEDGEMENT]:
    AgentAcknowledgementTask,
};
